import { CloseOutlined } from "@ant-design/icons";
import { PutResult } from "@aws-amplify/storage";
import { ActionIcon, Loader, Progress, Textarea } from "@mantine/core";
import { Storage } from "aws-amplify";
import { t } from "i18next";
import React, { FocusEvent } from "react";
import ConfirmModal from "./ConfirmModal";
import { BsCheckCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import { UploadFileProps } from ".";
import { theme } from "../../config/theme";
import { isPDF } from "../../hooks/useHandleS3";
import { ApprovalStatus, PositionImage, UploadStatus } from "../../interfaces";
import {
  createImgThumbnail,
  getFileNameWithoutFolderName,
  getFileSizeInMb,
} from "../../utils";
import { WarningIcon } from "../../assets/svgs";
import BulkPhotoView from "../common/BulkPhotoView";
import { IoIosDocument } from "react-icons/io";

import { API, graphqlOperation } from "aws-amplify";
// @ts-expect-error type exists
import { createActivityLog } from "../../graphql/mutations";
import { UserOrder } from "../../interfaces";

const CustomerOrderDataCard = ({
  item,
  order,
  showField,
  onRemove,
  onComplete = () => {},
  onHandleComment = () => {},
  setCurrent = () => {},
  setModalApproveVisible = () => {},
  disabled = false,
  showGalleryPreview = false,
}: {
  item: UploadFileProps;
  showField: boolean;
  order: UserOrder;
  onRemove: () => void;
  onComplete?: ({ key }: { key: string }) => void;
  onHandleComment?: (value: UploadFileProps) => void;
  setCurrent?: (value: PositionImage | null) => void;
  setModalApproveVisible?: (value: boolean) => void;
  disabled?: boolean;
  showGalleryPreview?: boolean;
}) => {
  const [progress, setProgress] = React.useState(0);
  const [upload, setUpload] = React.useState<Promise<PutResult> | null>(null);
  const [showGallery, setShowGallery] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<string>(
    item.positionImage?.comment ?? ""
  );
  const [showConfirmModal, setShowConfirmModal] =
    React.useState<boolean>(false);
  const [uploadThumbnail, setUploadThumbnail] =
    React.useState<Promise<PutResult> | null>(null);

    const generateThumbnail = async (item: UploadFileProps) => {
      const img = new Image();
      img.src = URL.createObjectURL(item.file);
      img.onload = async () => {
        const thumbnail = await createImgThumbnail(
          0,
          item.key,
          item.file.type,
          img
        );
        const thumbnailResponse = Storage.put(
          item.positionImage?.thumbnail || item.key,
          thumbnail,
          {
            level: "public",
            resumable: true,
            progressCallback(progressObject: { loaded: number; total: number }) {
              Math.round(
                (progressObject.loaded / progressObject.total) * 100
              );
            },
            completeCallback: async (event: { key?: string }) => {
              if (event.key) {
                
              } else {
                console.error("Upload completed but no key was returned.");
              }
            },
            errorCallback: (err: { message: any }) => {
              console.error("Unexpected error while uploading", err);
              toast.error(
                err?.message || `Unable to upload file:${item.positionImage?.thumbnail}`
              );
            },
          }
        );
        setUploadThumbnail(thumbnailResponse);
      };
    };
    
  const startUpload = async (item: UploadFileProps) => {
    console.trace(item);
    const fileName = item.key;
    
    if (!isPDF(item.file) && showField) {
      generateThumbnail(item);
    }
  
    const uploadResponse = Storage.put(fileName, item.file, {
      level: "public",
      resumable: true,
      progressCallback(progressObject: { loaded: number; total: number }) {
        const calculated = Math.round(
          (progressObject.loaded / progressObject.total) * 100
        );
        console.trace(`Uploaded ${fileName}: ${calculated}`);
        setProgress(calculated);
      },
      completeCallback: async (event: { key?: string }) => {
        if (event.key) {
          console.trace(`Successfully uploaded ${event.key}`);
          setProgress(100);
          onComplete({ key: event.key });
        } else {
          console.error("Upload completed but no key was returned.");
        }
      },
      errorCallback: (err: { message: string }) => {
        console.error("Unexpected error while uploading", err);
        toast.error(err?.message || `Unable to upload file:${item.file.name}`);
      },
    });
    setUpload(uploadResponse);
  };
  
  
  
  

  const handleRemove = async () => {
    // cancel the upload
    setShowConfirmModal(true);
  };
  const handleConfirm = async () => {
    // Annahme: "upload" und "uploadThumbnail" sind in diesem Kontext definiert
    if (upload) {
      await Storage.cancel(upload);
      setUpload(null);
    }
    if (uploadThumbnail) {
      await Storage.cancel(uploadThumbnail);
    }
    onRemove();
    setShowConfirmModal(false); // Modal schließen
  };
  const handleCancel = () => {
    setShowConfirmModal(false); // Modal schließen ohne Aktion
  };
  const UpdateConfirm = async (
    oldNote?: string,
    NewNote?: string,
    orderId?: string,
    updatedBy?: string
  ) => {
    // Log Activity
    const addressChange = {
      oldNote: oldNote,
      NewNote: NewNote,
    };
    const logDetails = {
      operation: "CHANGE",
      field: "comment",
      value: JSON.stringify(addressChange),
      updatedBy: updatedBy,
      orderItemActivityLogsId: orderId,
      typename: "activityLog",
      // ... Weitere Felder, falls benötigt
    };

    try {
     await API.graphql(
        graphqlOperation(createActivityLog, { input: logDetails })
      );
    } catch (error) {
      console.error("Fehler beim Erstellen des Activity Logs:", error);
    }
  };
  const [previousValue, setPreviousValue] = React.useState<string>(
    item.positionImage?.comment ?? ""
  );
  const handleFocusEvent = (e: FocusEvent<HTMLTextAreaElement>) => {
    const positionImage = item.positionImage;
    if (!positionImage) return;
    onHandleComment({
      ...item,
      positionImage: { ...positionImage, comment: e.target.value ?? "" },
    });
  };

  React.useEffect(() => {
    // CHECK IF status is not started, then start the upload
    console.trace(item);
    if (item?.uploadStatus === UploadStatus.NOT_STARTED) {
      // start upload
      startUpload(item);
    } else if (item?.uploadStatus === UploadStatus.DONE) {
      setShowGallery(true);
      setProgress(100);
    }
    return () => {
      if (upload) {
        Storage.cancel(upload);
      }
      setUpload(null);
    };
  }, [item]);

  return (
    <div
      data-approved={item.positionImage?.approvalStatus === ApprovalStatus.Yes}
      className={
        disabled && item.positionImage?.approvalStatus === ApprovalStatus.No
          ? "card-auto cursor-not-allowed"
          : "card-auto cursor-pointer"
      }
      style={{
        border:
          item.positionImage?.approvalStatus === ApprovalStatus.Yes
            ? "3px solid #34C759"
            : item.positionImage?.approvalStatus === ApprovalStatus.No
            ? "3px solid crimson"
            : 0,
        marginTop: "20px",
        padding: "16px",      
      }}
      onClick={() => {
        if (
          !disabled &&
          item.positionImage?.approvalStatus === ApprovalStatus.No
        ) {
          setCurrent(item.positionImage ?? null);
          setModalApproveVisible(true);
        }
      }}
    >
      <div style={{ direction: "rtl" }}>
        <ActionIcon disabled={disabled} onClick={() => handleRemove()}>
          <CloseOutlined />
        </ActionIcon>
      </div>
      {progress === 100 &&
        !showGallery &&
        isPDF(item.file) &&
        showGalleryPreview && (
          <>
            <React.Fragment>
              <React.Fragment>
                <span className="row row-center" style={{ fontSize: 18 }}>
                  {t("generatingImagePreviewFew").toString()}
                </span>
              </React.Fragment>
            </React.Fragment>
            <p className="upload-status__progress pb-16">
              <Loader size={28} />
            </p>
          </>
        )}
      {progress === 100 && showGallery && showGalleryPreview && (
        <BulkPhotoView
          file={item.positionImage?.thumbnail}
          isPdf={isPDF(item.file)}
        />
      )}
      <div className="grid">
        <div>
          {(progress !== 100 || !showGalleryPreview) && (
            <IoIosDocument size={"3rem"} className="mb-10" />
          )}
        </div>
        <div>
          <h4 className="overflow-wrap-break-word">
            {getFileNameWithoutFolderName(item?.key)}
          </h4>
          <span>{item?.file?.size && getFileSizeInMb(item?.file?.size)}MB</span>
          <div className="grid row-v-center align-progress-bar">
            <div>
              <Progress
                value={progress ?? 0}
                size={"sm"}
                color={
                  progress === 100 ? theme.colors?.green?.[9] : theme.black
                }
              />
            </div>
            <div>
              <span>
                {progress === 100 ? (
                  <BsCheckCircleFill color={theme.colors?.green?.[9]} />
                ) : (
                  `${progress ?? 0}%`
                )}
              </span>
            </div>
          </div>
          {showField && (
            <>
              <p className="my-10">{t("commentField").toString()}</p>
              <div className="w-sx">
                <Textarea
                  disabled={progress !== 100 || disabled}
                  value={value}
                  className="mt-10"
                  radius={"sm"}
                  minRows={3}
                  onChange={(event) => {
                    setValue(event.currentTarget.value);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onBlur={(e) => {
                    const newValue = e.currentTarget.value;
                    UpdateConfirm(
                      previousValue,
                      newValue,
                      order.id,
                      order.email
                    );
                    handleFocusEvent(e);
                    // Setze den vorherigen Wert für die nächste Iteration
                    setPreviousValue(newValue);
                  }}
                  placeholder={t("commentField")}
                ></Textarea>
              </div>
            </>
          )}
        </div>
        <div className="text-center row gap-8">
          {item.positionImage?.approvalStatus === ApprovalStatus.No && (
            <div
              className={`${!disabled && "cursor-pointer"}`}
              style={{ maxWidth: "10px" }}
              onClick={() => {
                if (!disabled) {
                  setCurrent(item.positionImage ?? null);
                  setModalApproveVisible(true);
                }
              }}
            >
              {!disabled && (
                <div>
                  <WarningIcon color="crimson" />
                  {t("Warning").toString()}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <ConfirmModal
        modalVisible={showConfirmModal}
        setModalVisible={setShowConfirmModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default CustomerOrderDataCard;
